/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useEffect } from "react";
import { useState } from "react";
/// ACTIONS ///
import { sortWOs } from "api/actions/wo/wo";
/// REACT COMPONENTS ///
import { Fragment } from "react";
/// MUI COMPONENTS ///
import Grid from "@mui/material/Grid";
import SortButton from "components/universal/button/sort";
/// STYLES ///
import { row_header_style } from "styles/universal/row";
/// SORT VALUES ///
import { NAME } from "values/sort/quote";
import { ADDRESS } from "values/sort/quote";
import { NUMBER } from "values/sort/quote";
import { EMAIL } from "values/sort/quote";
import { DATE } from "values/sort/quote";

export default function WOsHeader() {
  const dispatch = useAppDispatch();
  const [sort_type, setSortType] = useState<number>(-1);
  const [sort_up, setSortUp] = useState<boolean>(false);

  useEffect(() => {
    dispatch(sortWOs(sort_type, sort_up));
  }, [dispatch, sort_type, sort_up]);

  const setSort = (type: number) => {
    if (sort_type === type) {
      setSortUp(prev => !prev);
    }
    else {
      setSortType(type);
      setSortUp(false);
    }
  }

  return (
    <Fragment>
      <Grid item xs={2.5} sx={row_header_style}>
        <SortButton text="Date" handleSort={() => setSort(DATE)} is_current={sort_type === DATE} is_up={sort_up} />
      </Grid>
      <Grid item xs={3} sx={row_header_style}>
        <SortButton text="Name" handleSort={() => setSort(NAME)} is_current={sort_type === NAME} is_up={sort_up} />
      </Grid>
      <Grid item xs={3.5} sx={row_header_style}>
        <SortButton text="Job Site" handleSort={() => setSort(ADDRESS)} is_current={sort_type === ADDRESS} is_up={sort_up} />
      </Grid>
      <Grid item xs={3} sx={row_header_style}>
        <SortButton text="Email" handleSort={() => setSort(EMAIL)} is_current={sort_type === EMAIL} is_up={sort_up} />
      </Grid>
    </Fragment>
  )
}

